import { render, staticRenderFns } from "./ForgotPasswordCard.vue?vue&type=template&id=486e5b74&scoped=true"
import script from "./ForgotPasswordCard.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCard.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordCard.vue?vue&type=style&index=0&id=486e5b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e5b74",
  null
  
)

export default component.exports